<div class="slice-background">
  <ng-content select="[slice-background]"></ng-content>
</div>
<div class="content">
  <!--  Important: must not have whitespace to ensure the :empty styles are triggered (as whitespace is preserved) -->
  <div class="slice-header"><ng-content select="h1,h2,h3"></ng-content></div>
  <div [class]="sliceContentClass"><ng-content></ng-content></div>
  <div [class]="sliceFooterClass"><ng-content select="[slice-footer]"></ng-content></div>
</div>
